module.exports = __webpack_public_path__ + "img/feature-smart-traffic.58fd29fc.jpg";